import { render } from "./numberControl.vue?vue&type=template&id=0b440834&scoped=true"
import script from "./numberControl.vue?vue&type=script&lang=js"
export * from "./numberControl.vue?vue&type=script&lang=js"

import "./numberControl.vue?vue&type=style&index=0&id=0b440834&scoped=true&lang=css"
import "./numberControl.vue?vue&type=style&index=1&id=0b440834&lang=css"
script.render = render
script.__scopeId = "data-v-0b440834"

export default script